import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;

  width: 100%;
  background-color: teal;
  padding: 50px;
  margin-top: 10px;

  @media (min-width: 576px) {
    flex-direction: row;
  }
`;

export const FollowMe = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 10px;

  p {
    color: white;
  }

  @media (min-width: 576px) {
    flex-direction: row;
  }
`;

export const Network = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  a{
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .icons {
    margin: 15px;
    height: 35px;
    width: 100%;   
    color: white;
  }

  @media (min-width: 576px) {
    .icons {
      margin: 5px;
      height: 25px;
      width: 100%;
      color: white;
    }
  }

  @media (max-width: 440px) {
    flex-direction: column;
  }
`;

export const Creator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }
  .heart {
    margin: 5px;
  }
`;
